<template>

    <transition name="fade">
        <slot v-if="show_if"></slot>
        <lottie style="height:8rem;" :options="{animationData: componentAnimationData}" v-else/>
    </transition>

</template>

<script>
    export default {

        props:{
            show_if:{
                default: false,
            },
        },

        data: function() {
            return {
                componentAnimationData: require('../assets/mine-loading.json'),
            }
        },

    }
</script>